<template>
  <div>
    <v-form @submit.prevent="reset" ref="form" lazy-validation v-model="valid">
      <v-text-field
        v-model="new_password"
        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show ? 'text' : 'password'"
        name="new_password"
        :label="$t('labels.new_password')"
        @click:append="show = !show"
        :rules="passwordRules"
        required
      ></v-text-field>

      <v-row align="center" justify="center" class="mt-1">
        <v-btn x-large color="success" type="submit" :disabled="!valid" v-text="$t('reset')"></v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'reset',
  data () {
    return {
      valid: true,
      new_password: null,
      passwordRules: [
        v => !!v || this.$t('validations.password_required'),
        v => (v && v.length >= 6) || this.$t('validations.password_invalid')
      ],
      show: null
    }
  },
  methods: {
    reset () {
      if (!this.$refs.form.validate()) {
        return false
      }

      var url = new URL(document.location.href)
      var obj = {}

      for (var pair of url.searchParams.entries()) {
        obj[pair[0]] = pair[1]
      }

      this.$store.dispatch('auth/process', {
        type: 'reset',
        callback: document.location.origin + this.$router.resolve({ name: 'auth' }).href,
        payload: {
          new_password: this.new_password,
          reset_code: obj.code,
          user_id: obj.user_id
        }
      }).then((res) => {
        if (res.status === 204) {
          this.$store.dispatch('addInfo', this.$t('notifications.password_changed'))
        }

        this.new_password = null
        this.show = null
        this.$router.push({ name: 'home' })
      }).catch((e) => {
        this.$store.dispatch('addError', e.message)
      })
    }
  }
}
</script>
